import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/auth/login", { email, password });
      signIn(response.data);
      navigate("/");
    } catch (error) {
      toast.error(formatError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="login-page">
      <span className="login-circle login-circle-top" aria-hidden="true" />
      <span className="login-circle login-circle-bottom" aria-hidden="true" />
      <section className="login-panel" data-testid="login-card">
        <img
          src="/intechify-login-logo.png"
          className="login-card-logo"
          alt="Intechify — IT. Integrity. Integrated."
          data-testid="login-logo"
        />
        <div className="login-intro">
          <p className="eyebrow">INTERNAL STAFF ACCESS</p>
          <h1>Support work, made visible.</h1>
          <p>Log the work your clients value — clearly and consistently.</p>
        </div>
        <form onSubmit={submit} className="login-form" data-testid="login-form">
          <label>
            Email address
            <input data-testid="login-email-input" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          </label>
          <label>
            Password
            <input data-testid="login-password-input" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required />
          </label>
          <button className="primary-button full-button" data-testid="login-submit-button" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </section>
    </div>
  );
}